import LoginActivity from "../components/admin/LoginActivity";
import AdminLayout from "../components/layout/AdminLayout";

export default function AdminUsers() {
  return <LoginActivity Layout={AdminLayout} canManage={false} />;
}
